/**
 * Maps the user's UI language code to the canonical English language name
 * used on experiences (live_guide_languages / audio_languages store names
 * like "English", "Spanish", "Catalan").
 */
export const langCodeToEnglishName = {
  en: 'English',
  es: 'Spanish',
  ca: 'Catalan',
  de: 'German',
  fr: 'French',
  it: 'Italian',
  pt: 'Portuguese',
  pl: 'Polish',
  ru: 'Russian',
  uk: 'Ukrainian',
  zh: 'Chinese',
  ja: 'Japanese',
  nl: 'Dutch',
};

/**
 * Pick the language to display on the card's language button.
 *
 * Rules:
 *  1. If the user's current UI language is available in the experience → use it.
 *  2. Catalan exception: if user is browsing in Catalan and Catalan is NOT
 *     available, fall back to Spanish if available.
 *  3. Otherwise fall back to English if available.
 *  4. Otherwise the first language in the list.
 *
 * @param {string[]} availableLangs - English language names available on the experience.
 * @param {string} userLang - Two-letter UI language code (e.g. "en", "ca", "ja").
 * @returns {string|null} - The chosen English language name, or null if list is empty.
 */
export function pickDisplayLang(availableLangs, userLang) {
  if (!availableLangs || availableLangs.length === 0) return null;
  const userLangName = langCodeToEnglishName[userLang];

  if (userLangName && availableLangs.includes(userLangName)) {
    return userLangName;
  }

  // Catalan-specific fallback chain → Spanish before English.
  if (userLang === 'ca' && availableLangs.includes('Spanish')) {
    return 'Spanish';
  }

  if (availableLangs.includes('English')) {
    return 'English';
  }

  return availableLangs[0];
}
